import { render, staticRenderFns } from "./ExtraManage.vue?vue&type=template&id=2b433ca0&scoped=true&"
import script from "./ExtraManage.vue?vue&type=script&lang=js&"
export * from "./ExtraManage.vue?vue&type=script&lang=js&"
import style0 from "./ExtraManage.vue?vue&type=style&index=0&id=2b433ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b433ca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VIcon,VSelect,VTextField})
